import { useCookies } from 'react-cookie';
import { SearchItemViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { IconTrash } from '@/features/icons';
import { SEARCH_HISTORY_LOCAL_KEY } from './constants';
import MobileSearchLink from './mobile-search-link';
interface Props {
  items: SearchItemViewModel[] | null;
}
function LastSearchHistory({
  items
}: Props) {
  const [,, removeCookie] = useCookies([SEARCH_HISTORY_LOCAL_KEY]);
  return <>
            <div className='mb-4 flex items-center justify-between leading-6 lg:mt-10 lg:px-1'>
                <span className='text-sm font-bold text-text-black lg:text-base'>آخرین جست‌وجوهای شما</span>
                <IconTrash className='ml-1 h-6 w-6 cursor-pointer text-text-darkGray' onClick={() => removeCookie(SEARCH_HISTORY_LOCAL_KEY)} data-sentry-element="IconTrash" data-sentry-source-file="last-search-history.tsx" />
            </div>
            <ul className='mr-2 text-text-black'>
                {items?.map(item => <li key={item.id} className='pb-2.5 text-sm lg:text-base'>
                        <MobileSearchLink href={getSearchResultItemURL(item)} item={item}>
                            <span>{item.nameFa}</span>
                        </MobileSearchLink>
                    </li>)}
            </ul>
        </>;
}
export default LastSearchHistory;